const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParcialIngles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1239.1 533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M179.6,158.8A59.6,59.6,0,1,0,120,218.3,59.6,59.6,0,0,0,179.6,158.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,157.9a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,178.9,157.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.024390242993833
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2,157.1a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,178.2,157.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.048780486942867
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6,156.3A59.6,59.6,0,1,0,118,215.8,59.6,59.6,0,0,0,177.6,156.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.073170730891901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,155.4A59.6,59.6,0,1,0,117.4,215,59.5,59.5,0,0,0,176.9,155.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.097560974840936
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,154.6a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,176.2,154.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.12195121878997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,153.7A59.6,59.6,0,1,0,116,213.3,59.6,59.6,0,0,0,175.6,153.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.146341462739004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9,152.9a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,174.9,152.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.170731706688038
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2,152.1a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,174.2,152.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.195121950637073
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.6,151.2A59.6,59.6,0,1,0,114,210.8,59.6,59.6,0,0,0,173.6,151.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.219512194586107
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.9,150.4A59.6,59.6,0,1,0,113.3,210,59.5,59.5,0,0,0,172.9,150.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.243902438535141
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2,149.6a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,172.2,149.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.268292682484175
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5,148.7A59.6,59.6,0,1,0,112,208.3,59.5,59.5,0,0,0,171.5,148.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.29268292643321
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,147.9a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,170.9,147.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.317073170382244
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,147.1a59.6,59.6,0,1,0-59.5,59.5A59.6,59.6,0,0,0,170.2,147.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.341463414331278
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5,146.2A59.6,59.6,0,1,0,110,205.8,59.5,59.5,0,0,0,169.5,146.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.365853658280313
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,145.4a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,168.9,145.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.390243902229347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2,144.6a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,168.2,144.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.414634146178381
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5,143.7A59.6,59.6,0,1,0,108,203.3,59.5,59.5,0,0,0,167.5,143.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.439024390127415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,142.9a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,166.9,142.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.46341463407645
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.2,142a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,166.2,142Z",
    style: {
      fill: "#afafaf",
      opacity: 0.487804878025484
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5,141.2A59.6,59.6,0,1,0,106,200.8,59.5,59.5,0,0,0,165.5,141.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.512195121974518
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8,140.4a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,164.8,140.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.536585365923552
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.2,139.5a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,164.2,139.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.560975609872587
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.5,138.7A59.6,59.6,0,1,0,104,198.3,59.6,59.6,0,0,0,163.5,138.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.585365853821621
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,137.9a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,162.8,137.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.609756097770655
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.2,137a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,162.2,137Z",
    style: {
      fill: "#afafaf",
      opacity: 0.634146341719689
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,136.2A59.6,59.6,0,1,0,102,195.7,59.6,59.6,0,0,0,161.5,136.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.658536585668724
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8,135.4a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,160.8,135.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.682926829617758
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,134.5a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,160.2,134.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.707317073566792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,133.7a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,159.5,133.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.731707317515826
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,132.8a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,158.8,132.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.75609756146486
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2,132a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,158.2,132Z",
    style: {
      fill: "#afafaf",
      opacity: 0.780487805413895
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5,131.2a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,157.5,131.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.804878049362929
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,130.3a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,156.8,130.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.829268293311963
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,129.5a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,156.1,129.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.853658537260997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,128.7a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,155.5,128.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.878048781210032
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8,127.8a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,154.8,127.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.902439025159066
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.1,127a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,154.1,127Z",
    style: {
      fill: "#afafaf",
      opacity: 0.9268292691081
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,126.2a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,153.5,126.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.951219513057134
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,125.3a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,152.8,125.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.975609757006168
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1,124.5A59.6,59.6,0,1,0,92.6,184,59.5,59.5,0,0,0,152.1,124.5Z",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.3,380.1a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,642.3,380.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.6,379.2a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,641.6,379.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.024390242993833
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,378.4A59.6,59.6,0,1,0,581.4,438,59.5,59.5,0,0,0,641,378.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.048780486942867
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.3,377.6a59.6,59.6,0,1,0-59.5,59.5A59.6,59.6,0,0,0,640.3,377.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.073170730891901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.6,376.7a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,639.6,376.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.097560974840936
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639,375.9a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,639,375.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.12195121878997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.3,375.1a59.6,59.6,0,1,0-59.5,59.5A59.6,59.6,0,0,0,638.3,375.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.146341462739004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.6,374.2a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,637.6,374.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.170731706688038
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637,373.4a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,637,373.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.195121950637073
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.3,372.6a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,636.3,372.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.219512194586107
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.6,371.7a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,635.6,371.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.243902438535141
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635,370.9a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,635,370.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.268292682484175
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.3,370a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,634.3,370Z",
    style: {
      fill: "#afafaf",
      opacity: 0.29268292643321
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.6,369.2a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,633.6,369.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.317073170382244
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.9,368.4a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,632.9,368.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.341463414331278
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.3,367.5a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,632.3,367.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.365853658280313
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.6,366.7a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,631.6,366.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.390243902229347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.9,365.9a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,630.9,365.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.414634146178381
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.3,365a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,630.3,365Z",
    style: {
      fill: "#afafaf",
      opacity: 0.439024390127415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.6,364.2A59.6,59.6,0,1,0,570,423.7,59.6,59.6,0,0,0,629.6,364.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.46341463407645
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.9,363.4a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,628.9,363.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.487804878025484
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.3,362.5a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,628.3,362.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.512195121974518
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.6,361.7A59.6,59.6,0,1,0,568,421.2,59.6,59.6,0,0,0,627.6,361.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.536585365923552
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.9,360.9a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,626.9,360.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.560975609872587
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.3,360a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,626.3,360Z",
    style: {
      fill: "#afafaf",
      opacity: 0.585365853821621
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.6,359.2A59.6,59.6,0,1,0,566,418.7,59.6,59.6,0,0,0,625.6,359.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.609756097770655
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.9,358.3a59.6,59.6,0,1,0-59.5,59.6A59.6,59.6,0,0,0,624.9,358.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.634146341719689
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.2,357.5a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,624.2,357.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.658536585668724
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.6,356.7A59.6,59.6,0,1,0,564,416.2,59.6,59.6,0,0,0,623.6,356.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.682926829617758
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.9,355.8a59.6,59.6,0,1,0-59.5,59.6A59.6,59.6,0,0,0,622.9,355.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.707317073566792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.2,355a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,622.2,355Z",
    style: {
      fill: "#afafaf",
      opacity: 0.731707317515826
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.6,354.2A59.6,59.6,0,1,0,562,413.7,59.6,59.6,0,0,0,621.6,354.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.75609756146486
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.9,353.3a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,620.9,353.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.780487805413895
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,352.5A59.6,59.6,0,1,0,560.7,412,59.5,59.5,0,0,0,620.2,352.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.804878049362929
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.6,351.7A59.6,59.6,0,1,0,560,411.2,59.6,59.6,0,0,0,619.6,351.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.829268293311963
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.9,350.8a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,618.9,350.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.853658537260997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.2,350a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,618.2,350Z",
    style: {
      fill: "#afafaf",
      opacity: 0.878048781210032
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.5,349.2A59.6,59.6,0,1,0,558,408.7,59.5,59.5,0,0,0,617.5,349.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.902439025159066
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.9,348.3a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,616.9,348.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.9268292691081
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.2,347.5A59.6,59.6,0,1,0,556.7,407,59.6,59.6,0,0,0,616.2,347.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.951219513057134
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.5,346.6A59.6,59.6,0,1,0,556,406.2,59.5,59.5,0,0,0,615.5,346.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.975609757006168
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.9,345.8a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,614.9,345.8Z",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.4,358.8C564.4,263.4,487,186,391.6,186S218.9,263.4,218.9,358.8A172.7,172.7,0,0,0,391.6,531.5C487,531.5,564.4,454.2,564.4,358.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.5,356.3c0-95.4-77.4-172.7-172.8-172.7S216.9,260.9,216.9,356.3a172.8,172.8,0,0,0,345.6,0Z",
    style: {
      fill: "#afafaf",
      opacity: 0.024390242993833
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.5,353.9A172.8,172.8,0,1,0,387.8,526.7C483.2,526.7,560.5,449.3,560.5,353.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.048780486942867
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.6,351.5c0-95.4-77.4-172.8-172.8-172.8S213,256.1,213,351.5s77.4,172.7,172.8,172.7S558.6,446.9,558.6,351.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.073170730891901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.6,349.1c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,556.6,349.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.097560974840936
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.7,346.6c0-95.4-77.4-172.7-172.8-172.7A172.8,172.8,0,1,0,554.7,346.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.12195121878997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.7,344.2A172.7,172.7,0,0,0,380,171.5c-95.4,0-172.8,77.3-172.8,172.7S284.6,517,380,517,552.7,439.6,552.7,344.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.146341462739004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.8,341.8c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,550.8,341.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.170731706688038
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.9,339.4c0-95.4-77.4-172.8-172.8-172.8S203.3,244,203.3,339.4s77.4,172.7,172.8,172.7S548.9,434.8,548.9,339.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.195121950637073
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.9,336.9A172.8,172.8,0,1,0,374.2,509.7,172.7,172.7,0,0,0,546.9,336.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.219512194586107
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545,334.5c0-95.4-77.4-172.7-172.8-172.7A172.7,172.7,0,0,0,199.5,334.5c0,95.4,77.3,172.8,172.7,172.8S545,429.9,545,334.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.243902438535141
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543,332.1c0-95.4-77.3-172.8-172.7-172.8S197.5,236.7,197.5,332.1s77.4,172.7,172.8,172.7A172.7,172.7,0,0,0,543,332.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.268292682484175
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.1,329.7c0-95.4-77.4-172.8-172.8-172.8S195.6,234.3,195.6,329.7A172.7,172.7,0,0,0,368.3,502.4C463.7,502.4,541.1,425.1,541.1,329.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.29268292643321
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.1,327.2A172.7,172.7,0,0,0,366.4,154.5c-95.4,0-172.8,77.3-172.8,172.7a172.8,172.8,0,1,0,345.5,0Z",
    style: {
      fill: "#afafaf",
      opacity: 0.317073170382244
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.2,324.8A172.8,172.8,0,1,0,364.5,497.6C459.9,497.6,537.2,420.2,537.2,324.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.341463414331278
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.3,322.4c0-95.4-77.4-172.8-172.8-172.8S189.7,227,189.7,322.4s77.4,172.7,172.8,172.7S535.3,417.8,535.3,322.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.365853658280313
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.3,320c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,533.3,320Z",
    style: {
      fill: "#afafaf",
      opacity: 0.390243902229347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.4,317.5c0-95.4-77.4-172.7-172.8-172.7A172.8,172.8,0,1,0,531.4,317.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.414634146178381
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.4,315.1A172.7,172.7,0,0,0,356.7,142.4c-95.4,0-172.8,77.3-172.8,172.7s77.4,172.8,172.8,172.8S529.4,410.5,529.4,315.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.439024390127415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.5,312.7c0-95.4-77.4-172.8-172.8-172.8S182,217.3,182,312.7s77.3,172.8,172.7,172.8S527.5,408.1,527.5,312.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.46341463407645
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.6,310.3c0-95.4-77.4-172.8-172.8-172.8S180,214.9,180,310.3,257.4,483,352.8,483,525.6,405.7,525.6,310.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.487804878025484
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.6,307.8A172.8,172.8,0,1,0,350.9,480.6,172.7,172.7,0,0,0,523.6,307.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.512195121974518
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.7,305.4c0-95.4-77.4-172.7-172.8-172.7S176.1,210,176.1,305.4s77.4,172.8,172.8,172.8S521.7,400.8,521.7,305.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.536585365923552
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.7,303c0-95.4-77.3-172.8-172.7-172.8a172.8,172.8,0,0,0,0,345.6C442.4,475.8,519.7,398.4,519.7,303Z",
    style: {
      fill: "#afafaf",
      opacity: 0.560975609872587
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.8,300.6c0-95.4-77.4-172.8-172.8-172.8S172.3,205.2,172.3,300.6A172.7,172.7,0,0,0,345,473.3C440.4,473.3,517.8,396,517.8,300.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.585365853821621
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.8,298.1A172.7,172.7,0,0,0,343.1,125.4c-95.4,0-172.8,77.3-172.8,172.7a172.8,172.8,0,1,0,345.5,0Z",
    style: {
      fill: "#afafaf",
      opacity: 0.609756097770655
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.9,295.7A172.8,172.8,0,1,0,341.2,468.5C436.6,468.5,513.9,391.1,513.9,295.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.634146341719689
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,293.3c0-95.4-77.4-172.8-172.8-172.8S166.4,197.9,166.4,293.3s77.4,172.8,172.8,172.8S512,388.7,512,293.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.658536585668724
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510,290.9c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,510,290.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.682926829617758
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.1,288.4c0-95.4-77.4-172.7-172.8-172.7A172.8,172.8,0,1,0,508.1,288.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.707317073566792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.1,286A172.7,172.7,0,0,0,333.4,113.3c-95.4,0-172.8,77.3-172.8,172.7S238,458.8,333.4,458.8,506.1,381.4,506.1,286Z",
    style: {
      fill: "#afafaf",
      opacity: 0.731707317515826
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.2,283.6c0-95.4-77.4-172.8-172.8-172.8S158.7,188.2,158.7,283.6,236,456.4,331.4,456.4,504.2,379,504.2,283.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.75609756146486
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.2,281.2c0-95.4-77.3-172.8-172.7-172.8S156.7,185.8,156.7,281.2s77.4,172.7,172.8,172.7A172.7,172.7,0,0,0,502.2,281.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.780487805413895
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.3,278.7A172.8,172.8,0,1,0,327.6,451.5,172.7,172.7,0,0,0,500.3,278.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.804878049362929
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.4,276.3c0-95.4-77.4-172.7-172.8-172.7S152.8,180.9,152.8,276.3s77.4,172.8,172.8,172.8S498.4,371.7,498.4,276.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.829268293311963
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.4,273.9c0-95.4-77.3-172.8-172.7-172.8a172.8,172.8,0,0,0,0,345.6C419.1,446.7,496.4,369.3,496.4,273.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.853658537260997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.5,271.5c0-95.4-77.4-172.8-172.8-172.8S149,176.1,149,271.5A172.7,172.7,0,0,0,321.7,444.2C417.1,444.2,494.5,366.9,494.5,271.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.878048781210032
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.5,269A172.7,172.7,0,0,0,319.8,96.3C224.4,96.3,147,173.6,147,269a172.8,172.8,0,1,0,345.5,0Z",
    style: {
      fill: "#afafaf",
      opacity: 0.902439025159066
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.6,266.6c0-95.4-77.4-172.7-172.8-172.7A172.7,172.7,0,0,0,145.1,266.6c0,95.4,77.3,172.8,172.7,172.8S490.6,362,490.6,266.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.9268292691081
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.7,264.2c0-95.4-77.4-172.8-172.8-172.8S143.1,168.8,143.1,264.2,220.5,437,315.9,437,488.7,359.6,488.7,264.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.951219513057134
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.7,261.8C486.7,166.4,409.4,89,314,89A172.8,172.8,0,1,0,486.7,261.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.975609757006168
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.8,259.3c0-95.4-77.4-172.7-172.8-172.7S139.2,163.9,139.2,259.3a172.8,172.8,0,0,0,345.6,0Z",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.8,259.3c0-95.4-77.4-172.7-172.8-172.7S139.2,163.9,139.2,259.3a172.8,172.8,0,0,0,345.6,0Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 553.9,
    cy: 344.7,
    rx: 60.6,
    ry: 61.2,
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5,342.8h-12a9.8,9.8,0,0,1-9.7-9.7v-4a9.8,9.8,0,0,1,9.7-9.7h11.9a9.7,9.7,0,0,1,9.7,9.7v4h0A9.7,9.7,0,0,1,262.5,342.8Zm-.1-15.9H250.5a2.4,2.4,0,0,0-2.3,2.2v4a2.4,2.4,0,0,0,2.3,2.2h11.9a2.2,2.2,0,0,0,2.3-2.2v-4A2.2,2.2,0,0,0,262.4,326.9Zm6,6.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.5,279.4H269a5.9,5.9,0,0,0-6,5.9V347H366.5V285.3A5.9,5.9,0,0,0,360.5,279.4Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,346.8H224.2a3.7,3.7,0,0,1-3.7-3.7,3.6,3.6,0,0,1,3.7-3.7H410a3.7,3.7,0,0,1,3.7,3.7A3.8,3.8,0,0,1,410,346.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.9,383.3a38.6,38.6,0,1,1,38.6-38.6A38.7,38.7,0,0,1,553.9,383.3Zm0-72.8A34.2,34.2,0,1,0,588,344.7,34.2,34.2,0,0,0,553.9,310.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.8,367.7a2.8,2.8,0,0,1-1.5-.4c-2.5-1.3-2.9-5.7-2.9-8.2,0-7.6-.5-13.5-6-15.6a59.4,59.4,0,0,0-6.9-2.3,4.5,4.5,0,0,1-3.5-4.1,7.7,7.7,0,0,1,4.1-7.6,6.8,6.8,0,0,1,2.5-.7c0-.3-.1-.6-.1-1.1a2.8,2.8,0,0,0-.7-1.9c-.6-.5-2.1-.3-3.2-.2l-1.8.2h-.2a33.2,33.2,0,0,0-1.5,5.5l-.2,1.2c-.6,2.6-2,3.4-3,3.6s-4.2-2.3-4.5-2.9a3.6,3.6,0,0,1-.4-1.3,13.7,13.7,0,0,1-5.1,3c-2.6.9-4.1-.1-4.8-.8-2.3-2.5-.4-8.2,1-11.3a2.3,2.3,0,0,1,2.9-1.2,2.2,2.2,0,0,1,1.2,3,18.3,18.3,0,0,0-1.7,6.1c2.5-.9,3.2-1.8,3.3-2l.2-.4,2.5-4.4a2.3,2.3,0,0,1,2.5-1.1,2.2,2.2,0,0,1,1.7,2c.1,1.4.2,3,.4,4.2,1-4.9,1.9-7.7,5.7-7.7H548c2-.2,4.6-.5,6.7,1.2a6.3,6.3,0,0,1,2.2,4.9c.3,2.6.4,4.2-.8,5.3a3,3,0,0,1-2.7.7,2.4,2.4,0,0,0-1.4.2,3.1,3.1,0,0,0-1.5,2.1c-.2.8-.1,1.2,0,1.3a65.7,65.7,0,0,1,7.5,2.5c8.8,3.3,8.8,13.1,8.8,19.6a13,13,0,0,0,.5,3.6c2.9-3,8.7-12.8,7.6-15.9-1.6-4.7-2.5-7,2.3-9.6,2.6-1.4,4-2.9,4-3.9a2.2,2.2,0,0,1,2.1-2.4,2.2,2.2,0,0,1,2.3,2.1c.2,3-1.9,5.8-6.3,8.1a4.3,4.3,0,0,0-1.2.8,21.9,21.9,0,0,0,1,3.4c1.2,3.5-1,8.7-3.1,12.5s-5,7.9-7.1,9.3A3.5,3.5,0,0,1,566.8,367.7Zm-26.5-35.6Zm-9.8-.8Zm3.2-2.3Zm0,0Zm0,0Zm0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.7,368.6l-.7-.2a2.2,2.2,0,0,1-1.4-2.8c3-8.8,4.3-10.5,6.5-12.4l-1.5-.6a12.1,12.1,0,0,1-4.4-2.2,9.8,9.8,0,0,0-2.1-1.7l-.8-.4a27.2,27.2,0,0,0-.9,5.8,2.3,2.3,0,0,1-2.5,2,2.2,2.2,0,0,1-2-2.4c.8-9.3,2.9-10.2,3.6-10.5a3,3,0,0,1,3,.4,9.2,9.2,0,0,0,1.9,1.3,12.6,12.6,0,0,1,3,2.3,19.2,19.2,0,0,0,2.8,1.3c2.5.9,4.8,1.8,5.2,4a3.4,3.4,0,0,1-1.2,3.1l-.9.7c-1.7,1.5-2.6,2.3-5.5,10.7A2.2,2.2,0,0,1,531.7,368.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3,
    cy: 122,
    rx: 60.6,
    ry: 61.2,
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,157H59a2.2,2.2,0,0,1-2.3-2.2V94.9a2.3,2.3,0,0,1,2-2.2L98,87a2.3,2.3,0,0,1,1.8.6,2.1,2.1,0,0,1,.8,1.6v65.6A2.2,2.2,0,0,1,98.4,157Zm-37.2-4.4H96.1V91.8l-34.9,5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,157H72.7a2.3,2.3,0,0,1-2.3-2.3V140.9a2.2,2.2,0,0,1,2.3-2.2H84.5a2.2,2.2,0,0,1,2.3,2.2v13.8A2.3,2.3,0,0,1,84.5,157Zm-9.6-4.5h7.4v-9.4H74.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2,
    y: 124.7,
    width: 6.9,
    height: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2,
    y: 108.5,
    width: 6.9,
    height: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7,157H98.4a2.2,2.2,0,0,1-2.3-2.2V112.2a2.3,2.3,0,0,1,.8-1.7,2.2,2.2,0,0,1,1.9-.4l23.3,4.8a2.2,2.2,0,0,1,1.8,2.2v37.7A2.2,2.2,0,0,1,121.7,157Zm-21.1-4.4h18.9V118.9L100.6,115Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,157a2.2,2.2,0,0,1-2.2-2.3v-8.6a2.2,2.2,0,0,1,4.4,0v8.6A2.2,2.2,0,0,1,110,157Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9,219.3a33.5,33.5,0,1,1,33.5-33.5A33.5,33.5,0,0,1,311.9,219.3Zm0-59.6a26.1,26.1,0,1,0,26,26.1A26.1,26.1,0,0,0,311.9,159.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.9,323.8h-.5a3.7,3.7,0,0,1-3.2-4.2l9-61.9a25.2,25.2,0,0,1,25.2-24.9h40.9a25.3,25.3,0,0,1,25.3,25.2v5.6a3.8,3.8,0,0,1-7.5,0v-5.6a17.8,17.8,0,0,0-17.8-17.8H291.4a17.8,17.8,0,0,0-17.8,17.8v.6l-9,62.1A3.8,3.8,0,0,1,260.9,323.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7,326.4H316.8a11.9,11.9,0,0,1-11.9-11.9V272.7a11.9,11.9,0,0,1,11.9-11.9h71.6a11.9,11.9,0,0,1,11.9,11.9v41.8a11.9,11.9,0,0,1-11.9,11.9h-12",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.4,329.8h-12a3.4,3.4,0,1,1,0-6.8h12a8.5,8.5,0,0,0,8.5-8.5V272.7a8.5,8.5,0,0,0-8.5-8.5H316.8a8.5,8.5,0,0,0-8.5,8.5v41.8a8.5,8.5,0,0,0,8.5,8.5h11.9a3.4,3.4,0,1,1,0,6.8H316.8a15.3,15.3,0,0,1-15.3-15.3V272.7a15.2,15.2,0,0,1,15.3-15.3h71.6a15.3,15.3,0,0,1,15.3,15.3v41.8A15.4,15.4,0,0,1,388.4,329.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.4,330.2h-12a3.8,3.8,0,0,1,0-7.6h12a8.1,8.1,0,0,0,8.1-8.1V272.7a8.2,8.2,0,0,0-8.1-8.2H316.8a8.2,8.2,0,0,0-8.2,8.2v41.8a8.2,8.2,0,0,0,8.2,8.1h11.9a3.8,3.8,0,1,1,0,7.6H316.8a15.7,15.7,0,0,1-15.7-15.7V272.7A15.7,15.7,0,0,1,316.8,257h71.6a15.7,15.7,0,0,1,15.7,15.7v41.8A15.8,15.8,0,0,1,388.4,330.2Zm-12-6.8a3,3,0,0,0,0,6h12a14.9,14.9,0,0,0,14.9-14.9V272.7a15,15,0,0,0-14.9-15H316.8a15,15,0,0,0-15,15v41.8a15,15,0,0,0,15,14.9h11.9a3,3,0,1,0,0-6H316.8a8.9,8.9,0,0,1-8.9-8.9V272.7a8.9,8.9,0,0,1,8.9-8.9h71.6a8.9,8.9,0,0,1,8.9,8.9v41.8a8.9,8.9,0,0,1-8.9,8.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.8,345.8H340.1a3.4,3.4,0,0,1-2.5-1.1,3.7,3.7,0,0,1-.9-2.7l3.9-35.8a3.4,3.4,0,0,1,3.4-3h17.6a3.4,3.4,0,0,1,3.4,3l4.2,35.8a3.8,3.8,0,0,1-.8,2.7A3.6,3.6,0,0,1,365.8,345.8ZM343.9,339H362l-3.4-29H347Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.7,260.5a1.1,1.1,0,0,1-1.1-1.2c0-4.1-.2-8.3-.4-12.5C525.7,130.2,429,38.8,312,38.8a220,220,0,0,0-139.9,50,1.1,1.1,0,1,1-1.4-1.7A221.4,221.4,0,0,1,312,36.6c118.2,0,215.9,92.3,222.4,210.1.3,4.2.4,8.4.4,12.6A1.1,1.1,0,0,1,533.7,260.5Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,482.1A222.8,222.8,0,0,1,89.2,259.3c0-4.7.2-9.5.5-14.2a219.4,219.4,0,0,1,3.8-29.3,1.1,1.1,0,0,1,2.2.4,217.1,217.1,0,0,0-3.8,29c-.3,4.7-.4,9.4-.4,14.1a220.5,220.5,0,0,0,386,145.8,1.2,1.2,0,0,1,1.6-.1,1.1,1.1,0,0,1,.1,1.6A222.8,222.8,0,0,1,312,482.1Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.1,194.3c17,0,24.2,2.2,30.7,7.4s12.1,16.4,12.1,26.9-4.5,21.4-11.3,26.9-14.8,8.1-29.9,8.1H695.3v40.1H677.9V194.3Zm-13.8,53.9h15.1c6.9,0,12.3-.7,17-3.7s7.8-8.2,7.8-15.6-3.4-13-8-15.7-10.2-3.6-17.4-3.6H695.3Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.5,303.7H826.2V289.6c-5.7,10.8-17.2,16.5-29.9,16.5-25.9,0-41.3-20.2-41.3-42.6,0-24.6,17.9-42.6,41.3-42.6,16,0,26.2,8.9,29.9,16.5V223.3h15.3Zm-71.1-39.9c.2,11.9,8.6,27.9,28.1,27.9,12.3,0,21-6.8,25-16a28.9,28.9,0,0,0,2.8-11.9,24.6,24.6,0,0,0-2.4-12c-3.8-9.3-12.8-16.6-25.7-16.6-16.8,0-27.8,13.3-27.8,28.4Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.3,223.3h14.5v11.8c4.6-9.5,13-14.1,24-14.2v15.4h-1.1c-14.5,0-22,7.9-22,23.9v43.5H860.3Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.8,235.2H903.3V223.3h14.5v-29h15.4v29h15.5v11.9H933.2v68.5H917.8Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.8,194.3h15.4v16.2H958.8Zm0,29h15.4v80.4H958.8Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.7,303.7h-15.4V289.6c-5.6,10.8-17.1,16.5-29.8,16.5-25.9,0-41.3-20.2-41.3-42.6,0-24.6,17.9-42.6,41.3-42.6,15.9,0,26.1,8.9,29.8,16.5V223.3h15.4Zm-71.1-39.9c.1,11.9,8.6,27.9,28.1,27.9,12.3,0,21-6.8,25-16a32.4,32.4,0,0,0,2.8-11.9,25.8,25.8,0,0,0-2.4-12c-3.8-9.3-12.9-16.6-25.7-16.6-16.9,0-27.8,13.3-27.8,28.4Z",
    style: {
      fill: "#004990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.5,194.3h15.4V303.7h-15.4Z",
    style: {
      fill: "#004990"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcialIngles);
export default __webpack_public_path__ + "static/media/parcial-ingles.3c61193f2aca80d21d7bcf4194ca2375.svg";
export { ForwardRef as ReactComponent };